import type { PopperProps } from "@mui/material";

export const formsDropdownSlotProps = (viewportInset: number) => ({
  popper: {
    placement: "bottom-start",
    modifiers: [
      { name: "flip", enabled: false },
      {
        name: "formsDropdownHeight",
        enabled: true,
        phase: "beforeWrite",
        requires: ["computeStyles"],
        fn: ({ state }) => {
          const viewportHeight =
            state.elements.popper.ownerDocument.documentElement.clientHeight;
          const inputBottom =
            state.elements.reference.getBoundingClientRect().bottom;
          state.elements.popper.style.setProperty(
            "--forms-dropdown-height",
            `${Math.max(0, viewportHeight - inputBottom - viewportInset)}px`,
          );
        },
      },
    ],
  } satisfies Partial<PopperProps>,
  listbox: {
    sx: {
      boxSizing: "border-box",
      maxHeight: "min(40vh, var(--forms-dropdown-height))",
    },
  },
  paper: {
    sx: {
      maxHeight: "var(--forms-dropdown-height)",
      overflowY: "auto",
    },
  },
});
